module.exports = __webpack_public_path__ + "static/media/pic9@2x.8fcbb221.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_146/img/pic9@2x.png
// module id = 1402
// module chunks = 0